import type { Messages } from '../messages.js'

/** Swedish. `drag` for flips: a move you spend, and the same word in every Swedish board game. */
export const sv: Messages = {
  tag: 'sv',

  readingDictionary: 'Läser ordlistan…',
  noWordList: 'Ingen ordlista för ”{language}”. Bygg en:  pnpm dictionary build',
  emptyWordList: 'Ordlistan för ”{language}” är tom.',

  flips: 'drag',
  score: 'poäng',
  words: 'ord',
  round: 'omgång',
  ticksLeftLabel: 'Återstående tid i omgången',
  typeAWord: 'skriv ett ord',
  tapPrompt: 'tryck för att ta eller lämna tillbaka, sedan {action}',

  boardOfTiles: 'Bräde med {n} brickor',
  faceDown: 'nedåtvänd',
  wildCard: 'joker',
  wildKey: 'vilken bokstav som helst',
  letterReplaced: '{from} blev {to}',
  letterSwap: 'BOKSTAVSBYTE!',
  spentTile: 'förbrukad bricka',
  hiddenWhilePaused: 'dold under pausen',
  letterInWord: '{letter}, bokstav {position} i ordet',

  completeWord: 'Lämna in ordet',
  completeShort: 'Lämna in',
  reset: 'Rensa',
  pause: 'Pausa',
  resume: 'Fortsätt',
  newGame: 'Nytt spel',
  paused: 'Pausat',
  outOfFlips: 'Inga drag kvar',
  finalResult: '{score} poäng på {words} under {rounds}',
  playAgain: 'Spela igen',
  share: 'Dela',
  shareCopied: 'Kopierat.',
  shareSelect: 'Kopiera detta:',

  lettersSelect: 'bokstäver väljer',
  keysWild: 'tas när du skriver en bokstav som ingen bricka visar',
  clearsEvery: 'rensar alla valda {letter}',
  undoLastLetter: 'ångrar sista bokstaven',
  noWordsYet: 'Inga ord än.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'redan hittat',
  reasonTooShort: 'för kort',
  reasonNotAWord: 'inget ord',
  reasonAllFound: 'du har redan alla',
  noSuchLetterUp: 'inget {letter} uppe',
  nothingUp: 'inget uppe',
  letterHidden: 'en bokstav gömde sig',
  shuffled: 'blandat',
  shuffledAndBilled: 'blandat, {flips} oanvända drag debiterade',
  tooFewLetters: 'För få bokstäver kvar',

  gameLanguage: 'språk',
  interfaceLanguage: 'gränssnitt',
  dictionarySize: '{common} vanliga av {full} ord',
  filterLanguages: 'Sök språk',
  noMatches: 'Inga träffar',

  nerdMode: 'expertläge',
  rules: 'Regler',
  difficulty: 'svårighet',
  difficultyNames: { easy: 'lätt', medium: 'medel', hard: 'svårt', insane: 'brutalt' },
  pausedNoBoard: 'Det här spelet hamnar inte på topplistan.',
  about: 'Om',
  themeLabel: 'tema',
  themeNames: { traditional: 'traditionellt', light: 'ljust', contrast: 'hög kontrast' },
  tiles: 'brickor (N)',
  secondsPerTick: 'sekunder / takt',
  holdTicks: 'hålltakter',
  minWord: 'kortaste ord',
  startingFlips: 'drag vid start',
  wildChance: 'jokerchans',
  replaceChance: 'chans för bokstavsbyte',
  hideChance: 'chans att en bokstav göms',
  wordCompleteMode: 'ordet klart',
  wordCompleteNames: { shuffle: 'blanda', spend: 'förbruka', keep: 'behåll' },
  flipEconomy: 'draghushållning',
  flipEconomyNames: {
    none: 'ingen',
    perLetter: 'per bokstav',
    fibonacci: 'fibonacci',
    overMinimum: 'över minimum',
  },
  repeatedLetterKey: 'tangent för dubbel bokstav',
  keySchemeNames: { cycle: 'växla', advance: 'gå vidare' },
  keySchemeHelp: {
    cycle:
      'A tar nästa lediga A, och när alla är i ordet rensar det dem. ' +
      'Skift+A rensar dem också.',
    advance: 'A tar nästa lediga A. Skift+A rensar varje A ur ordet.',
  },

  whatThatMeans: 'Vad det betyder',
  factRound: 'en omgång',
  factWholeBoardUp: 'hela brädet uppe',
  factRoundCosts: 'en omgång kostar',
  factFlipsBuy: 'startdragen räcker till',
  factThisBoard: 'detta bräde',
  factBoardHadToAdmit: 'brädet måste tillåta',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, längsta {longest}',
  wordsIncludingOneOf: '{words} varav ett på {ceiling}',
  scorelessRounds: '{rounds} utan poäng',

  whatAWordPays: 'Vad ett ord ger',
  columnLetters: 'bokstäver',
  columnCost: 'kostnad',
  columnPoints: 'poäng',
  columnFlips: 'drag',
  columnNet: 'netto',

  canonicalRules: 'Officiella regler för {difficulty}.',
  customRules: 'Ändrat från förvalet. Poäng med egna regler rankas inte.',
  applyAndStart: 'Tillämpa och starta nytt spel',
  changesNextGame: 'Ändringar gäller från nästa spel.',
  presets: 'Förval:',

  start: 'Starta',
  restart: 'Börja om',
  quit: 'Avsluta',
  quitTitle: 'Avsluta det här spelet?',
  restartTitle: 'Starta om det här spelet?',
  restartConfirm: 'Starta om',
  quitConfirm: 'Avsluta',
  keepPlaying: 'Fortsätt spela',
  personalBest: 'Dina bästa spel',
  newPersonalBest: 'Nytt personbästa.',
  columnRank: '#',
  notRanked: 'Egna regler, så det här spelet rankas inte.',
  notRankedPaused: 'Klockan stannade, så det här spelet rankas inte.',
  rankOfTotal: '{rank} av {total}',

  howToPlay: 'Så spelar du',

  backToGame: 'Tillbaka till spelet',
  welcomeTitle: 'Välkommen till Blinkered',
  tutorialSkip: 'Hoppa över',
  tutorialNext: 'Nästa',
  tutorialBack: 'Tillbaka',
  tutorialStart: 'Börja spela',
  tutorialHideAgain: 'Visa inte igen',
  tutorialProgress: '{n} av {total}',
  tutorialSkipTitle: 'Hoppa över introduktionen?',
  tutGoalTitle: 'Blinkered är en kapplöpning',
  tutGoalBody:
    'Du börjar spelet med ett bestämt antal drag, och varje bricka som vänds kostar ett drag. När dragen tar slut är spelet över. Ord ger drag, och ju längre ordet är, desto fler drag får du.',
  tutSpentBody:
    'Bokstäver du använder i ett ord vänds ned fram till nästa omgång. Bara ett bokstavsbyte ändrar vilka bokstäver som ligger på brädet.',
  tutChangeTitle: 'Bokstäver kan ändras',
  tutSameLetters:
    'Såg du ett ord du inte hann spela? Samma bokstäver kommer tillbaka nästa omgång, blandade på nya platser.',
  tutPickLetters: 'Tryck på de bokstäver du vill ha, i ordning, för att bilda ett ord.',
  tutMoreTurn: 'Brickorna fortsätter vändas medan du tänker, så en bättre bokstav kan vara på väg.',
  tutTapBack:
    'Tog du fel? Tryck på den igen för att lämna tillbaka den. Vilken som helst, inte bara den sista.',
  tutComplete: 'Tryck på Klar när ordet är färdigt.',
  htBoardTitle: 'Brädet',
  htBoardBody:
    'Brickorna vänds upp en i taget, i slumpmässig ordning. Av de uppvända brickorna bildar du ord.',
  htWordsTitle: 'Orden',
  htWordsBody:
    'Bilda ett ord av de uppvända brickorna genom att skriva eller klicka på bokstäverna i ordning.',
  htFlipsTitle: 'Dragen',
  htFlipsBody:
    'Varje bricka som vänds kostar ett drag. Ett färdigt ord lägger tillbaka drag till ditt saldo, och långa ord ger mer. När dragen tar slut är spelet över.',
  htRoundTitle: 'Omgången',
  htRoundBody:
    'När omgångens sista bricka vänds ligger hela brädet uppe ett ögonblick. Sedan vänds brickorna ned och blandas, och en ny omgång börjar.',
  htLanguagesTitle: 'Språken',
  htLanguagesBody:
    '{n}. Varje bräde går att lösa med ord folk faktiskt använder. Ett ovanligt ord räknas ändå, om ordlistan kan det.',
  htKeysTitle: 'Tangentbordet',
  htWildTitle: 'Jokrar',
  htWildBody:
    'Ibland dyker det upp en joker i stället för en bokstav. En joker gäller som vilken bokstav som helst som bildar ett giltigt ord. Ett ord du redan gjort räknas inte.',
  htHideTitle: 'Bokstäver som gömmer sig',
  htHideBody:
    'På de svårare nivåerna kan en uppvänd bokstav vända sig tillbaka av sig själv och komma tillbaka senare i rundan. Tidslinjen får ett extra streck för det, i rött. Bokstäver du redan har tagit vänder sig inte tillbaka.',
  tutHideBody:
    'På de svårare nivåerna kan en uppvänd bokstav vända sig tillbaka av sig själv och komma tillbaka senare i rundan. Bokstäver du redan har tagit vänder sig inte tillbaka.',
  htSwapTitle: 'Bokstäver som byts',
  htSwapBody:
    'Ibland byts en bokstav ut mot en annan mellan omgångarna. Du ser vilken bokstav som togs bort och vilken som lades till.',
  htLevelsTitle: 'Nivåerna',
  htLevelEasy:
    'Samma tolv bokstäver hela partiet, så du hinner lära dig dem och hålla en ordlista i huvudet. Brickorna vänds långsamt och hela brädet syns tillräckligt länge för att du ska hinna välja klart dina bokstäver.',
  htLevelMedium:
    'Då och då byts en bokstav, och då blir det svårare att hålla reda på ord du tänkt lägga senare. Mindre tid att titta och mindre att tänka.',
  htLevelHard:
    'Ord på tre bokstäver räknas inte längre, och en bokstav byts ungefär varannan omgång. Brädet hinner knappt synas innan det blandas om.',
  htLevelInsane:
    'Allt på en gång, i full fart. Brädet blandas nästan direkt efter det sista draget.',
  htTouchTitle: 'Pekskärmen',
  htTouchBody:
    'Tryck på en uppvänd bricka för att ta dess bokstav. Tryck på en bokstav du redan tagit för att lämna tillbaka den. Lämna in och Rensa ligger under brädet.',

  accountTitle: 'Ditt konto',
  menuProfile: 'Min profil',
  menuGames: 'Mina spel',
  menuPublicPage: 'Min offentliga sida',
  menuSignedInAs: 'Inloggad som',
  signIn: 'Logga in',
  signOut: 'Logga ut',
  signInTitle: 'Logga in eller skapa konto',
  signInLead: 'Ett konto sparar dina spel, på alla enheter du spelar på.',
  signInKeepGame: 'Logga in för att spara det här spelet, och alla efter det.',
  continueWithApple: 'Fortsätt med Apple',
  continueWithGoogle: 'Fortsätt med Google',
  signInOr: 'eller',
  emailLabel: 'E-post',
  codeLabel: 'Kod',
  emailMeACode: 'Mejla mig en kod',
  working: 'Ett ögonblick…',
  sendNewCode: 'Skicka en ny kod',
  codeSent: 'Kolla mejlen. Koden gäller i 10 minuter.',
  notNow: 'Inte nu',
  badEmail: 'Det ser inte ut som en e-postadress.',
  badCode: 'Koden fungerade inte. Koder går ut efter 10 minuter och gäller en gång.',
  serverBusy: 'Kunde inte nå servern. Försök igen om en stund.',
  serverDown: 'Kunde inte nå servern.',
  offline: 'Offline',
  leaderboardTitle: 'Topplista',
  leaderboardEmpty: 'Inga spel på den här topplistan än. Bli först.',
  leaderboardWouldBe: 'Var det här spelet skulle hamna',
  leaderboardThisGame: 'Det här spelet',
  leaderboardRanksHere: 'Var det här spelet hamnar',
  leaderboardOutside: 'Utanför topp fem.',
  tutAccountTitle: 'Behåll dina poäng',
  tutAccountBody:
    'Ett konto sparar dina spel, sätter dina poäng på topplistan och behåller din profil.',
  ssoCancelled: 'Inloggningen avbröts.',
  ssoExpired: 'Det tog för lång tid. Logga in igen.',
  ssoNoUsername: 'Kontot kunde inte skapas färdigt. Försök igen om en stund.',
  ssoFailed: 'Det gick inte. Försök igen, eller använd din e-post.',
  tabProfile: 'Profil',
  countryAny: 'Säger inte',
  findCountry: 'Sök länder',
  usernameLabel: 'Användarnamn',
  bioLabel: 'Presentation',
  countryLabel: 'Land',
  bioHint: 'Inga länkar. {left}/{max}',
  save: 'Spara',
  saving: 'Sparar…',
  saved: 'Sparat.',
  nameTaken: 'Någon har redan det namnet.',
  nameTooShort: 'Lite längre, tack.',
  nameTooLong: 'Det är för långt.',
  nameBadCharacters: 'Bara bokstäver, siffror, bindestreck och understreck.',
  nameBadEdges: 'Det måste börja och sluta med en bokstav eller siffra.',
  nameMixedScripts: 'Välj ett alfabet och håll dig till det.',
  nameReserved: 'Det liknar ett namn vi delar ut själva. Välj ett annat.',
  nameUnusable: 'Det namnet går inte att använda.',
  bioTooLong: 'En presentation rymmer högst {max} tecken.',
  bioHasLink: 'Länkar är inte tillåtna i en presentation.',
  bioHasControl: 'Det innehåller tecken som inte får finnas här.',
  bioUnusable: 'Den presentationen går inte att använda.',
  gamesHeading: 'Spel',
  gamesEmpty: 'Inget här än. Spel du spelar inloggad dyker upp här.',
  gamesEmptyShort: 'Inget här än.',
  gamesLoading: 'Läser dina spel…',
  theirGamesLoading: 'Läser deras spel…',
  profileLoading: 'Läser profilen…',
  playerNotFound: 'Det finns ingen här med det namnet.',
  columnWhen: 'När',
  columnRounds: 'omgångar',
  columnGame: 'Spel',
  gameLoading: 'Läser spelet…',
  gameUnreadable: 'Det här spelet gick inte att läsa.',
  gameNotRanked: 'Spelat med ändrade regler, så det räknas inte.',
  detailNotKept: 'Orden och brädena för det här spelet sparas inte längre.',
  openingBoard: 'Startbrädet',
  roundByRound: 'Runda för runda',
  roundNothing: 'inget hittat',
  changeReplaced: '{letter} ersatt på plats {slot}',
  changeWildOn: '{letter} jokerbricka på plats {slot}',
  changeWildOff: '{letter} joker borta från plats {slot}',
  keepThisGame: 'Spara det här spelet',
  savedToYourGames: 'Sparat bland dina spel.',

  reportThis: 'Rapportera',
  reportHeading: 'Rapportera det här',
  reportTheName: 'Namnet',
  reportTheBio: 'Presentationen',
  reportTheScore: 'Poängen',
  reportWhy: 'Vad är det för fel på det? Frivilligt.',
  reportSend: 'Skicka rapporten',
  reportSent: 'Tack. Någon tittar på det.',
  reportSignIn: 'Logga in för att rapportera något.',
  reportGone: 'Det finns inte längre.',
  reportCancel: 'Avbryt',

  deleteAccount: 'Ta bort mitt konto',
  deleteAccountWhat:
    'Det här tar bort din profil och alla spel du har sparat, för gott. Det går inte att ångra.',
  deleteAccountAsk: 'Skicka mig en kod',
  deleteConfirm: 'Ta bort för gott',
  deleteGone: 'Ditt konto är borta. Tack för att du spelade.',
  deleteNoAddress:
    'Det finns ingen bekräftad adress på det här kontot, så en borttagning kan inte kontrolleras. Hör av dig och vi gör det för hand.',

  rulesetFacts: 'Ord på {letters} · en ny bricka var {seconds}',
  plurals: {
    words: { one: '{n} ord', other: '{n} ord' },
    rounds: { one: '{n} omgång', other: '{n} omgångar' },
    flips: { one: '{n} drag', other: '{n} drag' },
    ticks: { one: '{n} takt', other: '{n} takter' },
    points: { one: '{n} poäng', other: '{n} poäng' },
    minLetters: { one: 'minst {n} bokstav', other: 'minst {n} bokstäver' },
    seconds: { one: '{n} sekund', other: '{n} sekund' },
  },
}
